import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDate,
  InMemoryBoolean,
} from "pbas-vue-components";
import { translate2 } from "../trans2";
import { i18n } from '@/plugins/i18n';


const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});
const BenefitRulesHeaders = [
  new InMemoryHeader({
    type: new InMemoryString("Identifier"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "globals.benefit",
    type: new InMemoryString("Coverage", {
      getString: (item) => translate2(item.Coverage, "Name") +" (" + translate2(item.Coverage, "Description") + ")"
    }),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "globals.status",
    type: new InMemoryString("BenefitStatus", {
      getString: (item) => i18n.t("enums." + item.BenefitStatus)
    }),
    visible: true,
    allowVisibilityChange: true,
    sortable: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.benefitrules.benefit_party",
    type: new InMemoryString("BenefitParty", {
      getString: (item) => i18n.t("enums." + item.BenefitParty)
    }),
    visible: true,
    allowVisibilityChange: true,
    sortable: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.benefitrules.eligibility_criteria",
    type: new InMemoryString("EligibilityCriteria", {
      getString: (item) => {
        if (item.CoverageStatuses) {
          return item.CoverageStatuses.map(o=>translate2(o, "Name")).concat(item.Classes).join(", ");
        } else if (item.Classes) {
          console.log(item.Classes)
          if (Array.isArray(item.Classes)) {
            return item.Classes.join(", ");
          } else {
            return item.Classes;
          }
        } else {
          return "";
        }
      },
      getHtml: (item, type) => {
        return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
        );
    }
    }),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.benefitrules.reduction",
    type: new InMemoryString("ReductionClauses", {
      getString: (item) => item.ReductionClauses?item.ReductionClauses.map(o=> {
        if (o.Percentage!==null && o.Percentage!==undefined) {
          return `${(parseFloat(o.Percentage) * 100).toFixed(2)}% at age ${o.Age}`;
        } else if (o.FlatAmount !== null && o.FlatAmount !== undefined) {
          return `${formatter.format(o.FlatAmount)} at age ${o.Age}`;
        } else {
          return "";
        }
      }).join(", "):"",
      getHtml: (item, type) => {
        if (item.ReductionClauses === null || item.ReductionClauses === undefined) {
          return "";
        }
        return item.ReductionClauses.map(o=> {
          if (o.Percentage!==null && o.Percentage!==undefined) {
            return `${(parseFloat(o.Percentage) * 100).toFixed(2)}% at age ${o.Age}</BR>`;
          } else if (o.FlatAmount !== null && o.FlatAmount !== undefined) {
            return `${formatter.format(o.FlatAmount)} at age ${o.Age}</BR>`;
          } else {
            return "</BR>";
          }
        }).join("")
      }
    }),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.benefitrules.termination",
    type: new InMemoryString("TerminationClause", {
      getString: (item) => {
        // console.log(item);
        if (item.TerminateAtAge && item.EliminationPeriodDays && item.TerminateOnRetirement) {
          return `Retirement or ${item.EliminationPeriodDays} days before ${item.TerminateAtAge}th Birthday`
        } else if (item.TerminateAtAge && item.TerminateOnRetirement) {
          return `Retirement or Age ${item.TerminateAtAge}`
        } else if (item.TerminateAtAge && item.EliminationPeriodDays) {
          return `${item.EliminationPeriodDays} days before ${item.TerminateAtAge}th Birthday`
        } else if (item.TerminateAtAge) {
          return `Age ${item.TerminateAtAge}`
        } else if (item.TerminateOnRetirement) {
          return "Retirement"
        } else {
          return ""
        }
      }
    }),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
];
export default BenefitRulesHeaders;
